// TODO: MOVE TO ZOLA-HELPERS

export const XS_MOBILE_MAX = 480;
export const MOBILE_MIN = 481;
export const MOBILE_MAX = 767;
export const TABLET_MIN = 768;
export const TABLET_MAX = 991;
export const DESKTOP_MIN = 992;
export const DESKTOP_MAX = 1199;
export const LG_DESKTOP_MIN = 1200;

export function isXsMobile() {
  return window.matchMedia(`(max-width: ${XS_MOBILE_MAX}px)`).matches;
}

export function isMobile() {
  return window.matchMedia(`(max-width: ${MOBILE_MAX}px)`).matches;
}

export function isTablet() {
  return window.matchMedia(`(min-width: ${TABLET_MIN}px) and (max-width: ${TABLET_MAX}px)`).matches;
}

export function isDesktop() {
  return window.matchMedia(`(min-width: ${DESKTOP_MIN}px)`).matches;
}

export function isLargeDesktop() {
  return window.matchMedia(`(min-width: ${LG_DESKTOP_MIN}px)`).matches;
}

export function notXsMobile() {
  return window.matchMedia(`(min-width: ${MOBILE_MIN}px)`).matches;
}

export function notMobile() {
  return window.matchMedia(`(min-width: ${TABLET_MIN}px)`).matches;
}

export function notTablet() {
  return window.matchMedia(`(max-width: ${MOBILE_MAX}px), (min-width: ${DESKTOP_MIN}px)`).matches;
}

export function notDesktop() {
  return window.matchMedia(`(max-width: ${TABLET_MAX}px)`).matches;
}

export function notLargeDesktop() {
  return window.matchMedia(`(max-width: ${DESKTOP_MAX}px)`).matches;
}

export function isHighPixelDensity() {
  return window.matchMedia('(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)').matches;
}
